import { fork } from 'redux-saga/effects';

import { fetchSalesReportSaga } from './sagas/fetchSalesReport';

export const statisticsSaga = function* () {
  yield fork(fetchSalesReportSaga);
};
